import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator"; 
import Wrapper from "../../components/Wrapper";
import { FcSearch , FcDownload} from "react-icons/fc";

 
const SupportFees = ()=>{

    const [supportFees, setSupportFees] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const[total,setTotal] = useState(0);
    const [fileName,setFileName] = useState("");

    const today = new Date().toLocaleDateString('en-CA');
    //const[searchDate, setSearchDate] = useState(today);
    const[dateFrom,setDateFrom] = useState(today);
    const[dateTo, setDateTo] = useState(today);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`supportFee?page=${page}`);
            setSupportFees(data.data);
            setLastPage(data.meta.last_page);
            setTotal(data.meta.total);

        }
        )();
    },[page]);
   

    const doSearch  = async (e)=>{
        
        const {data} = await axios.get(`supportFeeSearch?page=${page}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
        setSupportFees(data.data);
        setLastPage(data.meta.last_page);
        setTotal(data.meta.total);
    }

    const doDownload = async () => {
        const now = new Date();
        const epochTime = now.getTime(); 
        const epochTimeInSeconds = Math.floor(epochTime / 1000);
        setFileName("appUsers" + epochTimeInSeconds);
        try {
            const { data } = await axios.post('appUserDownload', {
                name:fileName,
                date_from:dateFrom,
                date_to:dateTo,
            }, { responseType: 'blob' });
            const blob = new Blob([data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }


    return (
        <Wrapper pageTitle={'Support Fees'}>
            
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
 
                        <div className="flex items-center my-3">
                            <label className="block text-sm mr-2">
                            
                                <input 
                                    type="date" 
                                    value={dateFrom}
                                    className="block w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                                    placeholder="Msisdn"
                                    onChange={e => setDateFrom(e.target.value)} 
                                />
                            </label>
                            <label className="block text-sm mr-2">
                            
                                <input 
                                    type="date" 
                                    value={dateTo}
                                    className="block w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                                    placeholder="Msisdn"
                                    onChange={e => setDateTo(e.target.value)} 
                                />
                            </label>
                            <button className="mr-2" onClick={doSearch}> <FcSearch title="Search by Date"/> </button>
                            <button onClick={doDownload}><FcDownload title="Download"/>  </button>
                        </div>

                    <div className="w-full overflow-x-auto bg-white text-right leading-10 text-gray-700 pr-2 mr-3">  Page <span className="rounded-md bg-gray-300 text-white py-1 px-3">{page}</span>/{lastPage} Total Records: {total} </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                   

                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Timein </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Trxcode </th>
                                    <th className="px-4 py-3">Sourceamount </th>
                                    <th className="px-4 py-3">Merchantrequestid </th>
                                    <th className="px-4 py-3">Paid </th>
 
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {supportFees.map((supportFee)=>{
                                         return(
                                             <tr key={supportFee.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{supportFee.id}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.amount}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.trx_code}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.source_amount}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.merchant_request_id}</td>
                                                 <td className="px-4 py-3 text-sm">{supportFee.paid}</td>
                                                  
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default SupportFees;